<template>
    <div class="header-search-block">
        <div class="input-block input-block--search">
            <input type="text" v-model="search" placeholder="Search among 560 products..." class="input-block--search-field">
            <div class="input-block--search-button">
                <svg class="svg-sprite-icon svg-sprite-unstyled icon-search">
                    <use xlink:href="/img/svg/symbol/symbol_unstyled.svg#i-search"></use>
                </svg>
            </div>
            <ul class="header-search-list" v-if="products.length && search.length">
                <li v-for="(product, index) in products" v-bind:key="index">
                    <a v-bind:href="'/en/product/' + product.id">
                        <img :src="'/upload/' + product.image" alt="">
                        <span>{{product.title}}</span>
                    </a>
                </li>
                <!-- <li>
                    <a href="#">
                        <img src="/img/carousel/3.jpg" alt="">
                        <span>Header</span>
                    </a>
                </li> -->
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        url: {
            type: String,
            required: false
        },
    },
    data: () => ({
        loading: false,
        search: '',
        products: []
    }),
    methods: {
        fetch() {
            this.loading = true;
            if(this.search.length) {
                axios.get(this.url, {
                params: {
                    search: this.search
                }
                }).then((res) => {
                    this.products = res.data.data
                    this.loading = false;
                });
            }
        },
    },
    watch: { 
        search: function(newVal, oldVal) { // watch it
            this.fetch();
        }
    }
}
</script>